const MenuIcon = ({ backgroundFill, strokeColor, strokeWidth, width }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 22.34 15.7"
      fill={backgroundFill}
      stroke={strokeColor}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      width={width}
    >
      <line x1="1" y1="1" x2="21.34" y2="1" />
      <line x1="1" y1="7.85" x2="21.34" y2="7.85" />
      <line x1="1" y1="14.7" x2="21.34" y2="14.7" />
    </svg>
  );
};

export default MenuIcon;
